
import { Component, Prop, Vue } from 'vue-property-decorator'
import { BannerManageImpl } from '@/commons/bannerManage'
import { BannerService } from '@/commons/bannerService'
import Projects from './HomeProjs.vue'
import projTitle from './HomeNewsTitle.vue'
import { ProductManager } from '@/commons/productManager'
import { ProductService } from '@/commons/productService'
import { IndexService } from '../service'

@Component({
  components: {
    Projects,
    projTitle
  }
})
export default class HorizontalMenu extends Vue {
  private pid = 0
  private projectSystemId = '1407587846018269186'
  private productManager = new ProductManager(new ProductService())

  async mounted () {
    await this.productManager.getProductTree()
  }
  // private manager = new BannerManageImpl(new BannerService())
  // async mounted () {
  //   this.manager.requestBannerList()
  //   const res = this.manager.getProjectSystemInfor()
  // }
}
